import { DataAttributeDefinitions, provideDataItem } from "scrivito"
import { ProjectsCount } from "shared/types/__generated__/graphql"

import { apolloClient } from "app/apolloRestLink"

import {
  ProjectKpiDocument,
  ProjectKpiQuery
} from "features/kpi/graphql/queries.generated"
import I18n from "i18next"

async function attributes(): Promise<DataAttributeDefinitions> {
  return {
    totalProjects: [
      "number",
      { title: I18n.t("editing:attributes.KPIs.projects.total.title") }
    ],
    last7: [
      "number",
      { title: I18n.t("editing:attributes.KPIs.projects.last7Days.title") }
    ],
    last30: [
      "number",
      {
        title: I18n.t("editing:attributes.KPIs.projects.last30Days.title")
      }
    ]
  }
}

export const ProjectKpiDataItem = provideDataItem("ProjectKPIs", {
  attributes,
  connection: {
    async get() {
      let projectsCount: ProjectsCount | null | undefined

      try {
        projectsCount = await apolloClient
          .query<ProjectKpiQuery>({
            query: ProjectKpiDocument
          })
          .then(res => {
            return res.data.projectKpi?.projectsCount
          })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch project KPIs!", error)
      }

      return {
        totalProjects: projectsCount?.total,
        last7: projectsCount?.dailyOverview?.last7,
        last30: projectsCount?.dailyOverview?.last30
      }
    }
  }
})
